import s from './municipios/state'
import * as a from './municipios/actions'
import * as m from './municipios/mutations'
import * as g from './municipios/getters'

export const state = s
export const actions = {...a}
export const mutations = {...m}
export const getters = {...g}
